import { useState, useEffect } from 'react';
import api from '../../api';

export default function VolumeModal({ product, storeId, onSelect, onClose }) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/containers/pos/${storeId}/product/${product.id}`)
      .then(r => {
        setOptions(r.data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [product.id, storeId]);

  function handleSelect(option) {
    onSelect({
      volume: parseFloat(option.volume),
      container: option,
    });
  }

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <div style={styles.header}>
          <h3 style={styles.title}>🍺 {product.name}</h3>
          <button style={styles.closeBtn} onClick={onClose}>✕</button>
        </div>
        <p style={styles.subtitle}>Оберіть об'єм</p>

        {loading ? (
          <p style={styles.loading}>Завантаження...</p>
        ) : options.length === 0 ? (
          <p style={styles.noOptions}>Варіанти тари не налаштовані</p>
        ) : (
          <div style={styles.optionsGrid}>
            {options.map((opt, i) => {
              const volume = parseFloat(opt.volume);
              const price = parseFloat(product.price) * volume;
              const containerPrice = parseFloat(opt.container_price);
              const total = price + containerPrice;
              const available = opt.available;

              return (
                <button
                  key={i}
                  style={{
                    ...styles.optionBtn,
                    ...(available ? {} : styles.optionBtnDisabled)
                  }}
                  onClick={() => available && handleSelect(opt)}
                  disabled={!available}
                >
                  <div style={styles.optionVolume}>{volume} л</div>
                  <div style={styles.optionPrices}>
                    <div style={styles.optionBeerPrice}>
                      пиво: {price.toFixed(2)} ₴
                    </div>
                    <div style={styles.optionContainerLine}>
                      + {opt.container_name}: {containerPrice.toFixed(2)} ₴
                    </div>
                  </div>
                  <div style={styles.optionTotal}>{total.toFixed(2)} ₴</div>
                  {!available && (
                    <div style={styles.optionOutStock}>Немає тари</div>
                  )}
                </button>
              );
            })}
          </div>
        )}

        <button style={styles.cancelBtn} onClick={onClose}>Скасувати</button>
      </div>
    </div>
  );
}

const styles = {
  overlay: { position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modal: { background:'#211c14', border:'1px solid #38301f', borderRadius:'16px', padding:'24px', maxWidth:'480px', width:'90%' },
  header: { display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'6px' },
  title: { color:'#f5a623', margin:0, fontSize:'18px' },
  closeBtn: { background:'transparent', border:'none', color:'#9a8a6e', fontSize:'20px', cursor:'pointer' },
  subtitle: { color:'#9a8a6e', margin:'0 0 20px', fontSize:'14px' },
  loading: { color:'#9a8a6e', textAlign:'center', padding:'20px' },
  noOptions: { color:'#ff6b6b', textAlign:'center', padding:'20px', fontSize:'14px' },
  optionsGrid: { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(130px, 1fr))', gap:'10px', marginBottom:'16px' },
  optionBtn: { background:'#1c1812', border:'2px solid #38301f', borderRadius:'12px', padding:'16px 12px', cursor:'pointer', textAlign:'center', color:'#fff' },
  optionBtnDisabled: { opacity:0.4, cursor:'not-allowed', border:'2px solid #38301f' },
  optionVolume: { fontSize:'28px', fontWeight:'bold', color:'#f5a623', marginBottom:'8px' },
  optionPrices: { marginBottom:'8px' },
  optionBeerPrice: { color:'#cbd5e0', fontSize:'12px', marginBottom:'2px' },
  optionContainerLine: { color:'#9a8a6e', fontSize:'11px' },
  optionTotal: { fontSize:'16px', fontWeight:'bold', color:'#5fbf8f', borderTop:'1px solid #38301f', paddingTop:'8px' },
  optionOutStock: { color:'#ff6b6b', fontSize:'11px', marginTop:'4px' },
  cancelBtn: { width:'100%', padding:'11px', background:'transparent', color:'#9a8a6e', border:'1px solid #38301f', borderRadius:'8px', cursor:'pointer', fontSize:'14px' },
};
